import React from 'react'
import BackgroundImageCard from '../../Components/common/BackgroundImageCard'
import { setColorPicker, setColorPickerDark } from '../../redux/slices/ThemeSlice';
import { useDispatch } from 'react-redux';

const DefaultBackgroundImages = ({backgroundImages, colorPicker, onApplyColorPicker, backgroundImageId, setImage, themeMode}) => {
    const dispatch = useDispatch();
    const onClickImageCard = (color, image) => {
        setImage(image);
        if(themeMode == "dark"){
            dispatch(setColorPickerDark(color))
        }else{
            dispatch(setColorPicker(color))
        }
    }

    return (
        <>
        {
            backgroundImages.map((image) => (
                image.systemDefault && image.darkMode == (themeMode == "dark") ? <BackgroundImageCard imageObject={image} location={image.location} key={image.id} id={image.id} color={colorPicker} onClick={color => onClickImageCard(color, image)} onApply={onApplyColorPicker} backgroundImageId={backgroundImageId} themeMode={themeMode} /> : null
            ))
        }
        </>
    )
}

export default DefaultBackgroundImages